import { useState } from "react";
import "./meetingdetails.css";
import Header from "./Header";
import Detailssection from "./Detailssection";
import momsection from "../../assets/notch_mom_yellow.png";
import MomDrawer from "./Meetingdrawer";
import Actionstate from "./Actionstate";
import Hexapi from "../../utility/HexAPI/Hexapi";

const Meetingdetails = ({ userid, setisInfo, meetingInfo, meetingAction, attachments,GetMeetingDetails }) => {
  console.log(attachments,"attachments")
  console.log(meetingInfo,"meetingInfo")
  const [showMom, setShowMom] = useState(false);

  const handleMeetingAction = async(query, queryArr, type) => {

    if (type === "REQUEST_START_MEETING") {
      const obj={
        query: query,
        queryArr: queryArr
      }
     const resp = await Hexapi(obj)
     if(resp[""].command ) {
     GetMeetingDetails()
     }
      console.log("Start meeting API call");
    }

    if (type === "REQUEST_END_MEETING") {
      console.log("End meeting API call");
    }

    if (type === "REQUEST_JOIN_MEETING") {
      console.log("Join meeting API call");
    }

    if (type === "REQUEST_LEAVE_MEETING") {
      console.log("Leave meeting API call");
    }

  };
  return (
    <div className="meetingdetails">
      <div className="meetingdetailinfo" style={{ position: "relative" }}>

        <Header info={meetingInfo} onClick={() => setisInfo(true)} />

        {meetingAction && meetingAction.length > 0 && (
          <Detailssection
            userID={userid}
            meetingInfo={meetingInfo}
            details={meetingAction}
          />
        )}

        {meetingInfo?.mom && (
          <div className="momsection" onClick={() => setShowMom(true)}>
            <img src={momsection} className="img-fluid" />
          </div>
        )}

<Actionstate
   meetingInfo={meetingInfo}
   userID={userid}
   onActionClick={handleMeetingAction}
/>
       <MomDrawer
       attachments={attachments}
  showMom={showMom}
  setShowMom={setShowMom}
  meetingInfo={meetingInfo}
  userid={userid}
/>

      </div>
    </div>
  );
};

export default Meetingdetails;